var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-loop-func */
import { parseISO } from 'date-fns';
import { GradeInfo, Grades, isTbd, } from '../../../../../landing/models/GradeInfo';
import { getColorByResultPosition } from '../../../../../landing/utils/TestHelper';
import { TestPositionColor } from '../../../Common/colors';
import { SortGroupType, } from '../../models/YearlyTableData';
import { DEFAULT_PIE_VALUES_BY_CATEGORY, DEFAULT_PIE_VALUES_BY_GRADE, } from '../../constants/diagrams';
import { compareByRows, compareRowsByProgressField, compareRowsBySortField, } from '../../utils';
import { Direction } from '../../types';
var API_CATEGORY_TO_CLIENT_CATEGORY = {
    below_30: '< 30%',
    between_30_and_50: '30% – 50%',
    between_50_and_80: '50% – 80%',
    between_80_and_100: '80% – 100%',
    over_100: '> 100%',
};
var adaptYearlyDashboardToClient = function (data) {
    var output = {
        progressData: {},
        distributionData: {},
        readinessData: {},
        studentsData: new Map(),
    };
    if (!data || typeof data !== 'object')
        return null;
    var nextGrade = isTbd(data.progressData.nextGroupGradeValue.toString())
        ? Grades.TBD
        : data.progressData.nextGroupGradeValue;
    if (data.progressData) {
        output.progressData = {
            average: data.progressData.average.toString(),
            pieData: [],
        };
        output.readinessData = {
            total: data.progressData.total.toString(),
            nextGradeReady: data.progressData.nextGradeReady.toString(),
            grade: GradeInfo.get(nextGrade),
            eoyReady: data.progressData.nextGradeReadyByEOY.toString(),
            eoyTestReady: Number.parseInt(data.progressData.completedEOY.toString(), 10),
        };
        if (typeof data.progressData.progressPieData === 'object')
            output.progressData.pieData = transformProgressPieData(data.progressData.progressPieData);
    }
    if (data.distributionData) {
        var currentGrade_1 = isTbd(data.progressData.groupGradeValue.toString())
            ? -2
            : data.progressData.groupGradeValue;
        output.distributionData = {
            currentWeekCount: data.distributionData.practiceWeeksCount,
            startYearDate: parseISO(data.distributionData.beginningDate),
            startYearPieData: [],
            currentPieData: [],
            grade: currentGrade_1,
        };
        if (typeof data.distributionData.currentGradePieData === 'object')
            output.distributionData.currentPieData = transformDistributionPieData(data.distributionData.currentGradePieData);
        if (typeof data.distributionData.startYearPieData === 'object')
            output.distributionData.startYearPieData = transformDistributionPieData(data.distributionData.startYearPieData);
    }
    var currentGrade = Number.parseInt(data.progressData.groupGradeValue.toString(), 10);
    if (data.students) {
        var groupedByLevel = groupByLevel(data.students, currentGrade);
        output.studentsData.set(SortGroupType.Level, groupedByLevel);
        var groupedByTime = groupByTime(data.students, currentGrade);
        output.studentsData.set(SortGroupType.Time, groupedByTime);
        var groupedByCurrentLevel = groupByCurrentGrade(data.students, currentGrade);
        output.studentsData.set(SortGroupType.Grade, groupedByCurrentLevel);
        var groupedByStudents = groupByStudent(data.students, currentGrade);
        output.studentsData.set(SortGroupType.None, groupedByStudents);
    }
    output.startGrade = data.minGrade;
    output.endGrade = data.maxGrade;
    output.currentGrade = currentGrade;
    output.isClassPremium = data.premium;
    return output;
};
var transformProgressPieData = function (data) {
    var output = DEFAULT_PIE_VALUES_BY_CATEGORY.slice();
    if (!Array.isArray(data))
        return output;
    data.forEach(function (_a) {
        var name = _a.name, students = _a.students;
        var category = API_CATEGORY_TO_CLIENT_CATEGORY[name];
        var pie = output.find(function (i) { return i.id === category; });
        if (pie) {
            pie.value = students.length;
            pie.students = students.map(function (studentName) { return ({
                name: studentName,
            }); });
        }
    });
    return output;
};
var transformDistributionPieData = function (data) {
    var values = DEFAULT_PIE_VALUES_BY_GRADE.slice();
    if (!Array.isArray(data))
        return values;
    var output = values.map(function (grade) {
        var gradeValue = data.find(function (i) { return grade.id === (isTbd(i.name.toString()) ? -2 : i.name); });
        if (gradeValue) {
            return __assign(__assign({}, grade), { value: gradeValue.students.length, students: gradeValue.students.map(function (studentName) { return ({
                    name: studentName,
                }); }) });
        }
        return __assign({}, grade);
    });
    return output;
};
var parseLevel = function (resultPosition, value) {
    var level = resultPosition;
    var val = value;
    if (resultPosition === undefined) {
        level = 'n/a';
        val = undefined;
    }
    else if (resultPosition === 'not_tested') {
        level = 'n/a';
        val = '-1';
    }
    return { level: level !== null && level !== void 0 ? level : '', value: val };
};
var parseTableRow = function (rows, groupGrade) {
    return rows.map(function (row) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var boyParsed = parseLevel((_a = row.boy) === null || _a === void 0 ? void 0 : _a.resultPosition, (_b = row.boy) === null || _b === void 0 ? void 0 : _b.visible_quantile);
        var moyParsed = parseLevel((_c = row.moy) === null || _c === void 0 ? void 0 : _c.resultPosition, (_d = row.moy) === null || _d === void 0 ? void 0 : _d.visible_quantile);
        var eoyParsed = parseLevel((_e = row.eoy) === null || _e === void 0 ? void 0 : _e.resultPosition, (_f = row.eoy) === null || _f === void 0 ? void 0 : _f.visible_quantile);
        var parsedRow = {
            studentName: row.name.toString(),
            minInWeek: Number.parseInt(row.minInWeek.toString(), 10),
            progress: Number.parseInt(row.progress.toString(), 10),
            growth: row.growth !== null && row.growth !== undefined
                ? Number.parseInt(row.growth.toString(), 10)
                : undefined,
            boy: boyParsed.value,
            boyInfo: {
                header: 'Placement Test',
                level: boyParsed.level,
                range: (_g = row.boy) === null || _g === void 0 ? void 0 : _g.rangeMessage,
                color: getColorByResultPosition((_h = row.boy) === null || _h === void 0 ? void 0 : _h.resultColor),
            },
            moy: moyParsed.value,
            moyInfo: {
                header: 'Mid-Year Test',
                level: moyParsed.level,
                range: (_j = row.moy) === null || _j === void 0 ? void 0 : _j.rangeMessage,
                color: getColorByResultPosition((_k = row.moy) === null || _k === void 0 ? void 0 : _k.resultColor),
            },
            eoy: eoyParsed.value,
            eoyInfo: {
                header: 'End-of-Year Test',
                level: eoyParsed.level,
                range: (_l = row.eoy) === null || _l === void 0 ? void 0 : _l.rangeMessage,
                color: getColorByResultPosition((_m = row.eoy) === null || _m === void 0 ? void 0 : _m.resultColor),
            },
            studentTimelineUrl: row.studentTimelineUrl.toString(),
            sort: row.assessmentOrder,
            startPoint: row.startPoint,
        };
        if (Array.isArray(row.grades)) {
            var startPushGap_1 = 0;
            var startPushGrade_1 = row.grades.length
                ? Number.parseInt(row.grades[0].gradeValue.toString(), 10)
                : -1;
            var _loop_1 = function (g) {
                var grade = Number.parseInt(g.gradeValue.toString(), 10);
                var color = getGradeColor(grade, groupGrade);
                var pushedColor = color;
                var pushed = g.gaps.some(function (gap) { return gap.replacedByTest; });
                parsedRow[grade] = {
                    pushed: pushed,
                    pushedColor: pushedColor,
                    info: g.gaps.map(function (gap) {
                        var start = gap.start, end = gap.end;
                        var pushedInGap = Boolean(gap.replacedByTest);
                        var push;
                        if (pushedInGap)
                            push = { startGrade: startPushGrade_1, startGap: startPushGap_1 };
                        startPushGap_1 = end;
                        startPushGrade_1 = grade;
                        if (start === end) {
                            if (start > 0) {
                                start--;
                            }
                            else {
                                end++;
                            }
                        }
                        return {
                            start: start,
                            end: end,
                            color: color,
                            push: push,
                        };
                    }),
                };
                var gap = parsedRow[grade];
                if (gap) {
                    var startGrade = (_q = (_p = (_o = gap.info.find(function (i) { return i.push; })) === null || _o === void 0 ? void 0 : _o.push) === null || _p === void 0 ? void 0 : _p.startGrade) !== null && _q !== void 0 ? _q : -1;
                    gap.pushedColor = getGradeColor(startGrade, groupGrade);
                }
            };
            for (var _i = 0, _r = row.grades; _i < _r.length; _i++) {
                var g = _r[_i];
                _loop_1(g);
            }
        }
        return parsedRow;
    });
};
var getGradeColor = function (grade, groupGrade) {
    var justBelowGrade = groupGrade - 1;
    if (grade < groupGrade && grade < justBelowGrade) {
        return TestPositionColor.FAR_BELOW;
    }
    if (grade === justBelowGrade) {
        return TestPositionColor.BELOW;
    }
    if (grade === groupGrade)
        return TestPositionColor.MEETS;
    return TestPositionColor.EXCEEDS;
};
var groupByLevel = function (students, groupGrade) {
    var tableData = { groupedData: [] };
    var studentsBelow = students.filter(function (s) { return s.testLevel.toString() === 'below_grade'; });
    var studentsParsedBelow = parseTableRow(studentsBelow, groupGrade);
    studentsParsedBelow.sort(function (a, b) {
        return compareRowsBySortField(a, b, Direction.Desc);
    });
    if (studentsParsedBelow.length)
        tableData.groupedData.push({
            group: { name: 'Below grade level', sort: 0 },
            rows: studentsParsedBelow,
        });
    var studentsOnGrade = students.filter(function (s) { return s.testLevel.toString() === 'on_grade'; });
    var studentsParsedOnGrade = parseTableRow(studentsOnGrade, groupGrade);
    studentsParsedOnGrade.sort(function (a, b) {
        return compareRowsBySortField(a, b, Direction.Desc);
    });
    if (studentsParsedOnGrade.length)
        tableData.groupedData.push({
            group: { name: 'On grade level', sort: 1 },
            rows: studentsParsedOnGrade,
        });
    var studentsTbdGrade = students.filter(function (s) { return s.testLevel.toString() === 'tbd_grade'; });
    var studentsParsedTbdGrade = parseTableRow(studentsTbdGrade, groupGrade);
    studentsParsedTbdGrade.sort(function (a, b) {
        return compareRowsBySortField(a, b, Direction.Desc);
    });
    if (studentsParsedTbdGrade.length)
        tableData.groupedData.push({
            group: { name: 'Level TBD', sort: 2 },
            rows: studentsParsedTbdGrade,
        });
    return tableData;
};
var groupByTime = function (students, groupGrade) {
    var tableData = { groupedData: [] };
    var studentsBelow15 = students.filter(function (s) { return s.minInWeekGroup.toString() === 'below_15'; });
    var studentsParsedBelow15 = parseTableRow(studentsBelow15, groupGrade);
    studentsParsedBelow15.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedBelow15.length)
        tableData.groupedData.push({
            group: { name: '<15 min/week', sort: 3 },
            rows: studentsParsedBelow15,
        });
    var studentsBelow1530 = students.filter(function (s) { return s.minInWeekGroup.toString() === 'between_15_and_30'; });
    var studentsParsedBelow1530 = parseTableRow(studentsBelow1530, groupGrade);
    studentsParsedBelow1530.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedBelow1530.length)
        tableData.groupedData.push({
            group: { name: '15-30 min/week', sort: 2 },
            rows: studentsParsedBelow1530,
        });
    var studentsBelow3045 = students.filter(function (s) { return s.minInWeekGroup.toString() === 'between_30_and_45'; });
    var studentsParsedBelow3045 = parseTableRow(studentsBelow3045, groupGrade);
    studentsParsedBelow3045.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedBelow3045.length)
        tableData.groupedData.push({
            group: { name: '30-45 min/week', sort: 1 },
            rows: studentsParsedBelow3045,
        });
    var studentsOver45 = students.filter(function (s) { return s.minInWeekGroup.toString() === 'over_45'; });
    var studentsParsedOver45 = parseTableRow(studentsOver45, groupGrade);
    studentsParsedOver45.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedOver45.length)
        tableData.groupedData.push({
            group: { name: '45+ min', sort: 0 },
            rows: studentsParsedOver45,
        });
    return tableData;
};
var groupByCurrentGrade = function (students, groupGrade) {
    var tableData = { groupedData: [] };
    var studentsPK = students.filter(function (s) { return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) === Grades.PK; });
    var studentsParsedPK = parseTableRow(studentsPK, groupGrade);
    studentsParsedPK.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedPK.length)
        tableData.groupedData.push({
            group: { name: 'Pre-Kindergarten', sort: 0 },
            rows: studentsParsedPK,
        });
    var studentsK = students.filter(function (s) { return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) === Grades.K; });
    var studentsParsedK = parseTableRow(studentsK, groupGrade);
    studentsParsedK.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedK.length)
        tableData.groupedData.push({
            group: { name: 'Kindergarten', sort: 1 },
            rows: studentsParsedK,
        });
    var studentsG1 = students.filter(function (s) { return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) === Grades.G1; });
    var studentsParsedG1 = parseTableRow(studentsG1, groupGrade);
    studentsParsedG1.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG1.length)
        tableData.groupedData.push({
            group: { name: 'Grade 1', sort: 2 },
            rows: studentsParsedG1,
        });
    var studentsG2 = students.filter(function (s) { return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) === Grades.G2; });
    var studentsParsedG2 = parseTableRow(studentsG2, groupGrade);
    studentsParsedG2.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG2.length)
        tableData.groupedData.push({
            group: { name: 'Grade 2', sort: 3 },
            rows: studentsParsedG2,
        });
    var studentsG3 = students.filter(function (s) { return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) === Grades.G3; });
    var studentsParsedG3 = parseTableRow(studentsG3, groupGrade);
    studentsParsedG3.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG3.length)
        tableData.groupedData.push({
            group: { name: 'Grade 3', sort: 4 },
            rows: studentsParsedG3,
        });
    var studentsG4 = students.filter(function (s) { return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) === Grades.G4; });
    var studentsParsedG4 = parseTableRow(studentsG4, groupGrade);
    studentsParsedG4.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG4.length)
        tableData.groupedData.push({
            group: { name: 'Grade 4', sort: 5 },
            rows: studentsParsedG4,
        });
    var studentsG5 = students.filter(function (s) { return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) === Grades.G5; });
    var studentsParsedG5 = parseTableRow(studentsG5, groupGrade);
    studentsParsedG5.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG5.length)
        tableData.groupedData.push({
            group: { name: 'Grade 5', sort: 6 },
            rows: studentsParsedG5,
        });
    var studentsTbd = students.filter(function (s) { return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) === Grades.TBD; });
    var studentsParsedTbd = parseTableRow(studentsTbd, groupGrade);
    studentsParsedTbd.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedTbd.length)
        tableData.groupedData.push({
            group: { name: 'Level TBD', sort: 7 },
            rows: studentsParsedTbd,
        });
    return tableData;
};
var groupByStudent = function (students, groupGrade) {
    var tableData = { groupedData: [] };
    var studentsParsed = parseTableRow(students, groupGrade);
    studentsParsed.sort(function (a, b) { return compareByRows(a, b, Direction.Desc); });
    if (studentsParsed.length)
        tableData.groupedData.push({
            group: { name: '', sort: 0 },
            rows: studentsParsed,
        });
    return tableData;
};
export { adaptYearlyDashboardToClient };
